import React from "react";
import { LinkedinLogo, InstagramLogo, ArrowUpRight } from "@phosphor-icons/react";
import useReveal from "../../../../lib/useReveal";
import "./contact.scss";

const EMAIL = "design.delaina@gmail.com";
const LINKEDIN = "https://www.linkedin.com/in/delaina-fernandes/";
const INSTAGRAM = "https://www.instagram.com/delaina.design/";

// One component serves both the home section and the footer that closes every
// project deck. `variant` only swaps the class prefix, so the deck stylesheet
// keeps addressing .footer-* exactly as before.
const Contact = ({ variant = "page", color, headingLevel = 2 }) => {
  const p = variant === "deck" ? "footer" : "contact";
  const H = `h${headingLevel}`;
  const ref = useReveal({ threshold: 0.15 });

  return (
    <section
      className={`${p}-section`}
      style={color ? { backgroundColor: color } : undefined}
      ref={ref}
      aria-labelledby={`${p}-heading`}
    >
      <div className={`${p}-inner`}>
        <H className={`${p}-heading`} id={`${p}-heading`} data-reveal>
          Contact
        </H>

        <p className={`${p}-text`} data-reveal style={{ "--d": 1 }}>
          GOT AN IDEA? LET'S MAKE IT REAL
        </p>

        <p className={`${p}-email`} data-reveal style={{ "--d": 2 }}>
          <a href={`mailto:${EMAIL}`} className="reset-link">
            <span>Design.Delaina@gmail.com</span>
            <ArrowUpRight size={22} weight="bold" aria-hidden="true" />
          </a>
        </p>

        <ul className={`${p}-image-grid`} data-reveal style={{ "--d": 3 }}>
          <li>
            <a
              href={LINKEDIN}
              className="reset-link social-link"
              target="_blank"
              rel="noreferrer"
              aria-label="LinkedIn"
            >
              <LinkedinLogo size={22} weight="fill" />
            </a>
          </li>
          <li>
            <a
              href={INSTAGRAM}
              className="reset-link social-link"
              target="_blank"
              rel="noreferrer"
              aria-label="Instagram"
            >
              <InstagramLogo size={22} weight="fill" />
            </a>
          </li>
        </ul>

        <p className="copyright-section">
          DESIGNED AND DEVELOPED BY DELAINA &amp; KEEGAN | DESIGN{" "}
          {new Date().getFullYear()}
        </p>
      </div>
    </section>
  );
};

export default Contact;
